<sb-section-toolbar class="mb-md">
  {{ 'Personal files' | translate }}
  <sb-search-input section-toolbar-actions class="w-60 min-w-0" [debounce]="300" [(value)]="searchQuery" />
  @if (permissions().canAdd) {
    <a
      section-toolbar-actions
      sb-button
      color="primary"
      [routerLink]="['', { outlets: { modal: ['employee-file', employeeId()] } }]"
    >
      <sb-icon name="attachment-2-regular" />
      {{ 'Add file' | translate }}
    </a>
  }
</sb-section-toolbar>

@if (loading()) {
  <sb-loading-state class="py-2xl" />
} @else if (files().length === 0) {
  <sb-card>
    <sb-empty-state
      class="py-2xl"
      icon="paperclip"
      [title]="'No files found' | translate"
      [description]="'Start adding them now' | translate"
    />
  </sb-card>
} @else {
  <div sbTableContainer>
    <table sbTable>
      <thead>
        <tr sbTableRow>
          <th sbTableHeaderCell>{{ 'Title' | translate }}</th>
          <th sbTableHeaderCell>{{ 'Expiration date' | translate }}</th>
          <th sbTableHeaderCell></th>
        </tr>
      </thead>
      <tbody>
        @for (file of currentPageFiles(); track file.id) {
          <tr sbTableRow>
            <td sbTableCell data-hj-suppress>{{ file.title }}</td>
            <td sbTableCell>{{ file.expiration_date | localeDate | default }}</td>
            <td sbTableCell align="right" class="whitespace-nowrap">
              @if (file.file_name) {
                <button
                  (click)="download(file)"
                  sb-icon-button
                  color="transparent"
                  [sbTooltip]="'Download' | translate"
                  [attr.aria-label]="'Download' | translate"
                >
                  <sb-icon name="download-3-regular" />
                </button>
              }
              @if (permissions().canEdit) {
                <button
                  [routerLink]="['', { outlets: { modal: ['employee-file', employeeId(), file.id] } }]"
                  sb-icon-button
                  color="transparent"
                  [sbTooltip]="'Edit' | translate"
                  [attr.aria-label]="'Edit' | translate"
                >
                  <sb-icon name="pencil-regular" />
                </button>
              }
              @if (permissions().canDelete) {
                <button
                  sb-icon-button
                  color="transparent"
                  [sbTooltip]="'Delete' | translate"
                  [attr.aria-label]="'Delete' | translate"
                  sbActionConfirm
                  (confirmed)="deleteFile(file)"
                >
                  <sb-icon name="delete-2-regular" />
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (pages().length > 1) {
    <sb-pagination
      class="mt-md block"
      [totalItems]="filteredFiles().length"
      [page]="page()"
      (pageChange)="onPageChange($event)"
    />
  }
}
